'use client'

import { useResponsive } from '@dustin-web/microsite-components/src/hooks'
import React from 'react'

type Props = {
  children: React.ReactNode
}
export function Mobile({ children }: Props) {
  const { isSmallScreen } = useResponsive()
  if (isSmallScreen) return <>{children}</>
  return null
}

export function Desktop({ children }: Props) {
  const { isSmallScreen } = useResponsive()
  if (!isSmallScreen) return <>{children}</>
  return null
}
